export function resolveNavigationRoute(params: {
    isOrgNode: boolean
    entityId: number
    currentPathname: string
    isContextSwap: boolean
    orgHasMultiDomainFlag: boolean
}): string | null {
    const { isOrgNode, entityId, currentPathname, isContextSwap, orgHasMultiDomainFlag } = params

    // Only rewrite route if on a domain/org entity page or root
    if (!/(^\/$)|(^\/(domains|organizations)\/[\d]+)/i.test(currentPathname)) {
        return null
    }

    // Strip existing entity prefix to get the current sub-route
    let subRoute = currentPathname.replace(/^\/(domains|organizations)\/[\d]+/i, '')

    if (isOrgNode) {
        // Org navigation: resolve to /#settings or /notifications based on flag
        subRoute = orgHasMultiDomainFlag ? '/notifications' : '/#settings'
    } else if (isContextSwap) {
        // Domain navigation with context swap (org→domain): default to /notifications
        subRoute = '/notifications'
    }
    // Domain navigation without context swap: preserve current sub-route

    const entityType = isOrgNode ? 'organizations' : 'domains'
    return `/${entityType}/${entityId}${subRoute}`
}
